const button = document.querySelector('.btn-up');

if (button) {
  if (document.querySelector('.hero__bottom-right')) {
    button.classList.add('btn-up--with-widget');
  }

  const toggleVisibility = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollY > 300) {
      button.classList.remove('btn-up_hide', 'hide');
    } else {
      button.classList.add('btn-up_hide', 'hide');
    }
  };

  toggleVisibility();

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  document.addEventListener('scroll', toggleVisibility, { passive: true });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  button.addEventListener('click', scrollToTop);
  button.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollToTop();
    }
  });
}